import cookies from './cookies'
import termsAndConditions from './termsAndConditions'
import termsOfUse from './termsOfUse'

const terms = {
  cookies,
  termsOfUse,
  termsAndConditions,
}

export default terms
